// extracted by mini-css-extract-plugin
export default {"contentContainer":"BankOptionTransformer_contentContainer__BDU5b","logoImage":"BankOptionTransformer_logoImage__bTcz+"};